var _excluded = ["date", "weeks", "activeMonth", "focusedDate"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { addMonths, isAfter, isBefore, isSameMonth } from 'date-fns';
import { flatten } from 'lodash';
import { createActiveMonth } from './createActiveMonth';
import { getDaysDictionary } from './getDaysDictionary';
import { getPartialWeeks } from './getPartialWeeks';

/**
 * isDateCanBeFocused - Checks if the target date is available to focus.
 * It will return true if the date is not disabled.
 */
var isDateCanBeFocused = _ref => {
  var _daysDictionary$date$;

  var {
    weeks,
    date
  } = _ref;
  var days = getDaysInMonth(weeks);
  var daysDictionary = getDaysDictionary(days);
  var isDisabled = (_daysDictionary$date$ = daysDictionary[date.getTime()]) === null || _daysDictionary$date$ === void 0 ? void 0 : _daysDictionary$date$.isDisabled;
  return !isDisabled;
};
/**
 * getClosestDateInMonth - Returns the first available day in the month based on the target date, and if it's before or after the focused date.
 */


var getClosestDateInMonth = _ref2 => {
  var _filteredDays$find;

  var {
    date,
    isBeforeFocusedDate,
    weeks
  } = _ref2;
  var daysInMonth = getDaysInMonth(weeks);
  var filteredDays = isBeforeFocusedDate ? daysInMonth.slice().reverse() : daysInMonth;
  return (_filteredDays$find = filteredDays.find(day => {
    var isInRange = isBeforeFocusedDate ? isBefore(day.date, date) : isAfter(day.date, date);
    return isInRange && !day.isDisabled;
  })) === null || _filteredDays$find === void 0 ? void 0 : _filteredDays$find.date;
};
/**
 * getDaysInMonth - Returns the days in the month from the weeks.
 */


var getDaysInMonth = weeks => flatten(weeks).filter(day => day !== null);
/**
 * findClosestDateToFocus - Finds the next available day to focus based on the target date.
 * In case the target is before or after the min/max date, it will return undefined.
 * otherwise, it will iterate through the months to find the next available date.
 */


export var findClosestDateToFocus = _ref3 => {
  var _getClosestDateInCurr;

  var {
    date,
    weeks,
    activeMonth,
    focusedDate
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded);

  // If the date is before the min date or after the max date, it returns undefined.
  if (props.isBeforeMinDate(date) || props.isAfterMaxDate(date)) return;
  var isBeforeFocusedDate = focusedDate && isBefore(date, focusedDate);
  var nextActiveMonth = createActiveMonth(addMonths(activeMonth.date, isBeforeFocusedDate ? -1 : 1)); // Search for the closest date in the current month

  var getClosestDateInCurrentMonth = () => isDateCanBeFocused({
    weeks,
    date
  }) ? date : getClosestDateInMonth({
    date,
    weeks,
    isBeforeFocusedDate
  }); // Search for the closest date in the next month for edge cases when the current month doesn't have any available date to focus.


  var getClosestDateInNextMonth = () => getClosestDateInMonth({
    date,
    weeks: getPartialWeeks(_objectSpread(_objectSpread({}, props), {}, {
      activeMonth: nextActiveMonth
    })),
    isBeforeFocusedDate
  }); // Sets the closest date in the current month / next month to focus if the date is in the current month.


  var dateToFocus = isSameMonth(date, activeMonth.date) && ((_getClosestDateInCurr = getClosestDateInCurrentMonth()) !== null && _getClosestDateInCurr !== void 0 ? _getClosestDateInCurr : getClosestDateInNextMonth()); // If the date is not found it will iterate through the months to find the next available date.

  return dateToFocus || findClosestDateToFocus(_objectSpread(_objectSpread({}, props), {}, {
    weeks: getPartialWeeks(_objectSpread(_objectSpread({}, props), {}, {
      activeMonth: nextActiveMonth
    })),
    date,
    focusedDate,
    activeMonth: nextActiveMonth
  }));
};
//# sourceMappingURL=findClosestDateToFocus.js.map